// 微信授权登陆的js

// 解析URL数据
function urlQuery (query, url) {
  const u = new URL(url || location.href)

  if (!u.search) return undefined

  let arr = []
  u.search.replace(/\?/ig, '').split('&').forEach(t => {
    arr = arr.concat(t.split('='))
  })

  if (arr.indexOf(query) > -1) {
    return arr[arr.indexOf(query) + 1]
  }

  return undefined
}

// get 请求数据
function getData (url, callback) {
  const request = new XMLHttpRequest()
  request.onreadystatechange = function () {
    if (request.readyState === 4) { // 监听readyState状态，HTTP状态码
      if (request.status === 200 || request.status === 0) {
        const data = JSON.parse(request.responseText)
        callback(null, data)
      }
    }
  }

  request.open('GET', url)
  request.send()
}

// 微信登录授权
function wxLogin () {
  if (navigator.userAgent.match(/micromessenger/ig) === null || location.host !== 'm.china.com.cn') return null

  if (localStorage.getItem('wxnicnname') !== null && new Date().getTime() - localStorage.getItem('wxnicnnametime') < 1000 * 60 * 60) {
    window.$wxuser = {
      nickname: localStorage.getItem('wxnicnname')
    }

    return null
  } else {
    localStorage.removeItem('wxnicnname')
    localStorage.removeItem('wxnicnnametime')
  }

  const baseURL = 'https://open.weixin.qq.com/connect/oauth2/authorize'
  const APPID = 'wx3915bce572d4c564'
  const redirectURI = window.encodeURIComponent(location.href)
  const code = urlQuery('code', location.href)

  if (code) {
    if (code === '-1') {
      return ''
    }

    // 用户同意授权，拿到了code
    console.log('微信授权登陆成功，code: ', code)
    // const url = 'https://k1.m.china.com.cn/app/wx/openid'
    const url = 'https://share.m.china.com.cn/login'
    getData(url + '?host=' + APPID + '&code=' + code + '&type=userinfo', (err, data) => {
      if (err) {
        console.log('获取微信token失败')
        console.log(err)
      } else {
        console.log('获取到微信用户信息了')
        console.log(data)
        window.$wxuser = data

        if (data.nickname) {
          localStorage.setItem('wxnicnname', data.nickname)
          localStorage.setItem('wxnicnnametime', new Date().getTime())
        }
      }

      history.pushState({}, '', '?code=-1' + location.hash)
    })
  } else {
    // 没有授权，索要授权
    console.log('去登陆')
    window.location.replace(`${baseURL}?appid=${APPID}&redirect_uri=${redirectURI}&response_type=code&scope=snsapi_userinfo&state=1#wechat_redirect`)
  }
}

export default wxLogin
